// tslint:disable-next-line export-name
export { default as messages } from "@apps/viewer/src/locales/da-dk.json";
